import api from '../../../../helpers/api';

export const getMyArtisanPublicInquiry = body =>
  api.post('public-artisan-inquiry/get-single-public-artisan-inquiry/', {
    ...body
  });

export const getMyArtisanPublicInquiries = body =>
  api.post(
    body.url
      ? body.url
      : '/public-artisan-inquiry/search-public-artisan-inquiries',
    body
  );

export const addArtisanPublicProposal = body =>
  api.post(`public-artisan-inquiry/add-public-artisan-proposal`, { ...body });

export const addArtisanPublicStagingProposal = body =>
  api.post(`public-artisan-staging-proposals/create`, { ...body });

export const editArtisanPublicProposal = body =>
  api.post(body.url? body.url:`public-artisan-inquiry/edit-public-artisan-proposal`, body);

export const editStagingArtisanPublicProposal = body =>
  api.post(`public-artisan-staging-proposals/update`, { ...body });

export const deleteArtisanPublicProposal = body =>
  api.post(`/public-artisan-inquiry/rem-public-artisan-proposal`, { ...body });
